import { useTranslation } from 'react-i18next';

import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'ko', label: '한국어' },
  { code: 'en', label: 'English' },
] as const;

export const LanguageSelector = () => {
  const { t, i18n } = useTranslation();
  const currentLang = i18n.language;

  const handleLanguageChange = () => {
    const nextLang = currentLang === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(nextLang);
  };

  const currentLabel =
    LANGUAGES.find((l) => l.code === currentLang)?.label ?? currentLang;

  return (
    <button
      onClick={handleLanguageChange}
      className="flex w-full items-center justify-between rounded-xl px-2 py-2 text-left transition-colors hover:bg-lemon-soft/40"
    >
      <div className="flex items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-lemon-soft/70 text-lemon-ink dark:text-lemon">
          <Globe size={18} />
        </span>
        <div>
          <p className="font-display text-base font-semibold tracking-tight">
            {t('settings.language')}
          </p>
          <p className="text-xs text-muted-foreground">{currentLabel}</p>
        </div>
      </div>
      <span className="flex items-center gap-2 rounded-full bg-lemon-soft/70 px-3 py-1 text-xs font-semibold text-lemon-ink ring-1 ring-lemon dark:text-lemon">
        <span className="h-1.5 w-1.5 rounded-full bg-lemon" />
        {currentLabel}
      </span>
    </button>
  );
};
